import {yupResolver} from '@hookform/resolvers/yup'
import {enqueueSnackbar} from 'notistack'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {Select} from '../../../../../../components/UI/Select'
import {useHoteleria} from '../../../../../../hooks/useHoteleria'
import {TabModel} from '../../../../../../models'
import {SelectOption} from '../../../../../../models/utility.model'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {changeStatusBedService} from '../../../../services/bed.service'
import {BedModel} from '../../../bed/model'
import {getSnackBarToast} from '../../../../../../util/snackBar'
import {Button} from '../../../../../../components/UI/Button'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  dataUpdate: any[]
}

const ModalUpdateStatus: FC<Props> = ({show, setShow, dataUpdate}) => {
  const handleClose = () => {
    setShow(false)
  }

  const [statusBed, setStatusBed] = useState<SelectOption[]>([])
  const [subStatusBed, setSubStatusBed] = useState<SelectOption[]>([])
  const {getMasterTable} = useCentralServices()
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const [loading, setLoading] = useState<boolean>(false)

  const newBedSchema = Yup.object().shape({
    EstadoCamaId: Yup.string().required('Estado de Cama es requerido'),
    SubEstadoCamaId: Yup.string().required('Sub Estado de Cama es requerido'),
  })

  const {
    setValue,
    handleSubmit,
    watch,
    setError,
    control,
    formState: {errors},
  } = useForm<any>({
    resolver: yupResolver(newBedSchema),
  })

  const onSubmit = async (dto: any) => {
    try {
      setLoading(true)
      const {data: res} = await changeStatusBedService(
        dto?.EstadoCamaId,
        dto?.SubEstadoCamaId,
        dto?.data,
      )
      if (!res.error) {
        setLoading(false)
        getSnackBarToast('Se actualizó con exito', 'success')
        handleClose()
        let obj: TabModel = {
          ...currentTabItem,
          loadingTable: true,
          updateFromOther: true,
        }
        changeCurrentTabItem(obj)
      } else {
        setLoading(false)
        getSnackBarToast(res.message, 'error')
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const getStatusBedFn = async () => {
    const data = await getMasterTable('EstadoCama', true)
    const mappedData = data?.filter((item) => item.codigo === '3' || item.codigo === '1')
    setStatusBed(mappedData)
  }

  const getSubStatusBedFn = async (statusPadre: string) => {
    const data = await getMasterTable('SubEstadoCama', true)
    const filteredData = data?.filter((item) => item.codigoPadre === statusPadre)
    const mappedMaster = filteredData?.map((master) => ({
      value: master.id,
      label: master.nombreCorto,
    }))
    setSubStatusBed(mappedMaster)
  }

  const handleStatusChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('EstadoCamaId', value)
    const filtered = statusBed.filter((item: any) => item.value === value)[0]?.codigo
    getSubStatusBedFn(filtered as any)
    setError('EstadoCamaId', {})
    setValue('SubEstadoCamaId', '')
  }

  useEffect(() => {
    getStatusBedFn()
    setValue('data', dataUpdate)
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Estado y SubEstado</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='mb-4'>
              <div className='d-flex row'>
                <div className='col-6'>
                  <label className='required'>Estado de Cama:</label>
                  <Select
                    control={control}
                    name='EstadoCamaId'
                    data={statusBed}
                    errors={errors}
                    onChangeValue={handleStatusChange}
                  />
                </div>
                <div className='col-6'>
                  <label className='required'>Sub Estado de Cama:</label>
                  <Select
                    control={control}
                    name='SubEstadoCamaId'
                    data={subStatusBed}
                    errors={errors}
                  />
                </div>
              </div>
            </div>
            {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>

              <button
                type='button'
                className='btn btn-primary'
                onClick={handleSubmit(onSubmit)}
                disabled={loading}
              >
                {loading && (
                  <div className='icon-container me-2'>
                    <i className='loader'></i>
                  </div>
                )}
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateStatus}
